// MOCK DATA (frontend-only). This will later be replaced by backend APIs.

export const brand = {
  name: "Ellipsonic",
  domain: "ellipsonic.com",
  tagline: "Engineering Intelligent Digital Solutions",
  subtagline:
    "AI‑Driven Software, Cloud, Data & Product Engineering for Modern Enterprises",
  contact: {
    address:
      "22, 1st Floor, Dr Puneeth Raj Kumar 100ft Road, 15th Cross Rd, JP Nagar 4th Phase, Bengaluru, Karnataka-560078 INDIA",
    phone: "+91 80733 65724",
    emails: ["reachus@ellipsonic.com", "careers@ellipsonic.com"],
  },
};

export const trust = {
  metrics: [
    { label: "Years of Experience", value: "7+" },
    { label: "Projects Delivered", value: "120+" },
    { label: "Engineers", value: "45+" },
  ],
  clients: [
    { name: "FinTech Partner" },
    { name: "Healthcare Network" },
    { name: "Retail Platform" },
    { name: "EdTech Brand" },
    { name: "Manufacturing Group" },
  ],
  partners: [
    { name: "AWS" },
    { name: "Azure" },
    { name: "GCP" },
    { name: "Snowflake" },
    { name: "Databricks" },
  ],
};

export const heroImages = {
  // Selected via vision expert agent (Unsplash). You approved adding a hero image.
  strongTech:
    "https://images.unsplash.com/photo-1644088379091-d574269d422f?auto=format&fit=crop&w=1400&q=80",
  aiPrism:
    "https://images.unsplash.com/photo-1752671235858-d12c200994fd?auto=format&fit=crop&w=1400&q=80",
  fiberOptic:
    "https://images.unsplash.com/photo-1562575214-da9fcf59b907?auto=format&fit=crop&w=1400&q=80",
  aiChip:
    "https://images.unsplash.com/photo-1697577418970-95d99b5a55cf?auto=format&fit=crop&w=1400&q=80",
};

export const services = [
  {
    slug: "ai-data-engineering",
    title: "AI & Data Engineering",
    summary:
      "Modern data platforms, RAG systems, and applied ML to turn raw signals into decision-grade intelligence.",
    problems: [
      "Disparate data sources and no single source of truth",
      "Slow analytics and unreliable dashboards",
      "AI pilots that don’t reach production",
    ],
    capabilities: [
      {
        title: "Data Platform Foundations",
        points: [
          "Lakehouse / warehouse architecture",
          "ETL/ELT pipelines with observability",
          "Data quality, lineage, governance",
        ],
      },
      {
        title: "Applied AI",
        points: [
          "RAG + enterprise knowledge search",
          "LLM app architecture and safety patterns",
          "MLOps for model lifecycle",
        ],
      },
    ],
    stack: [
      "Python",
      "Spark",
      "dbt",
      "Kafka",
      "Snowflake",
      "Databricks",
      "OpenSearch",
    ],
    useCases: [
      {
        title: "Customer 360 & propensity",
        impact: "Unified analytics layer with measurable lift in conversion.",
      },
      {
        title: "Ops Copilot",
        impact: "LLM-assisted troubleshooting for faster MTTR.",
      },
    ],
  },
  {
    slug: "software-development",
    title: "Software Development",
    summary:
      "Product-grade web and mobile engineering with measurable performance, quality and security baselines.",
    problems: [
      "Legacy modernization with minimal downtime",
      "Scaling reliability without slowing delivery",
      "Security and compliance needs",
    ],
    capabilities: [
      {
        title: "Full‑Stack Engineering",
        points: [
          "React + API platforms",
          "Microservices & modular monoliths",
          "Testing strategy and automation",
        ],
      },
      {
        title: "Quality & Security",
        points: [
          "Shift-left quality gates",
          "OWASP-aligned secure coding",
          "Performance and load baselining",
        ],
      },
    ],
    stack: ["React", "FastAPI", "Node.js", "PostgreSQL", "MongoDB", "Redis"],
    useCases: [
      { title: "Modernization", impact: "Reduced release cycle time from weeks to days." },
      { title: "Platform builds", impact: "API-first architecture enabling faster integrations." },
    ],
  },
  {
    slug: "cloud-devops",
    title: "Cloud & DevOps",
    summary:
      "Cloud-native delivery: secure landing zones, CI/CD, IaC and cost-aware operations.",
    problems: [
      "Unpredictable cloud costs",
      "Manual deployments and slow release cycles",
      "Security posture gaps",
    ],
    capabilities: [
      {
        title: "Cloud Foundations",
        points: [
          "Landing zones and guardrails",
          "Network design and identity",
          "Backup/DR strategies",
        ],
      },
      {
        title: "DevOps Automation",
        points: [
          "CI/CD pipelines",
          "IaC with Terraform",
          "SRE dashboards and alerts",
        ],
      },
    ],
    stack: ["AWS", "Azure", "GCP", "Terraform", "Kubernetes", "GitHub Actions"],
    useCases: [
      { title: "Cloud migration", impact: "Lowered infra cost with right-sizing + autoscaling." },
      { title: "Delivery automation", impact: "Zero-downtime deployments and stronger rollbacks." },
    ],
  },
  {
    slug: "enterprise-solutions",
    title: "Enterprise Applications",
    summary:
      "ERP/CRM enhancements, integrations, and enterprise-grade workflows that survive scale.",
    problems: [
      "Disconnected workflows and manual approvals",
      "Rigid tooling that blocks new initiatives",
      "Integration complexity across systems",
    ],
    capabilities: [
      {
        title: "Enterprise Integration",
        points: [
          "API management patterns",
          "Event-driven integration",
          "Identity and access models",
        ],
      },
      {
        title: "Workflow Modernization",
        points: [
          "Digitization of approval chains",
          "Auditability and compliance logging",
          "Role-based experiences",
        ],
      },
    ],
    stack: ["SAP", "Salesforce", "Dynamics", "MuleSoft", "Boomi", "Kafka"],
    useCases: [
      { title: "Process automation", impact: "Fewer handoffs and improved audit readiness." },
      { title: "Integration hubs", impact: "Faster time-to-integrate across tools." },
    ],
  },
  {
    slug: "digital-transformation",
    title: "Digital Transformation",
    summary:
      "From discovery to delivery: reimagine customer and employee experiences with measurable outcomes.",
    problems: [
      "Fragmented customer journeys",
      "Low adoption due to poor UX",
      "No clear operating model",
    ],
    capabilities: [
      {
        title: "Experience Strategy",
        points: [
          "Journey mapping",
          "Service design",
          "Analytics-driven iteration",
        ],
      },
      {
        title: "Modern Delivery",
        points: [
          "Agile at enterprise scale",
          "Change management alignment",
          "Continuous improvement loops",
        ],
      },
    ],
    stack: ["Figma", "GA4", "Segment", "Amplitude", "React", "Design systems"],
    useCases: [
      { title: "Self-service portals", impact: "Higher CSAT via faster resolutions." },
      { title: "Digitized operations", impact: "Shorter cycle time in internal workflows." },
    ],
  },
  {
    slug: "consulting-architecture",
    title: "Consulting & Architecture",
    summary:
      "Founder-led advisory for architecture decisions, modernization roadmaps, and delivery alignment.",
    problems: [
      "Architecture debt accumulating silently",
      "Mismatch between business goals and tech choices",
      "Vendor lock-in risk",
    ],
    capabilities: [
      {
        title: "Technology Strategy",
        points: [
          "Target architecture and roadmap",
          "Build vs buy evaluation",
          "Security posture review",
        ],
      },
      {
        title: "Execution Alignment",
        points: [
          "Operating model + agile coaching",
          "Delivery quality baselines",
          "Portfolio prioritization support",
        ],
      },
    ],
    stack: ["Architecture reviews", "Cloud reference patterns", "Threat modeling"],
    useCases: [
      { title: "Modernization plan", impact: "Clear phased roadmap with risk controls." },
      { title: "Platform strategy", impact: "Reduced rework by aligning teams early." },
    ],
  },
];

export const industries = [
  {
    slug: "bfsi",
    title: "BFSI",
    challenges: [
      "Regulatory compliance and auditability",
      "Fraud detection and real-time risk",
      "Legacy modernization",
    ],
    solutions: [
      "Secure data platforms and analytics",
      "AI-assisted customer service",
      "Workflow automation for operations",
    ],
    sampleUseCases: [
      "Loan origination automation",
      "Transaction anomaly detection",
      "Customer 360 dashboards",
    ],
  },
  {
    slug: "healthcare",
    title: "Healthcare",
    challenges: [
      "Interoperability across systems",
      "Data privacy and access controls",
      "Operational efficiency",
    ],
    solutions: [
      "HIPAA-style security patterns",
      "Data integration and patient journey insights",
      "Automation for admin workflows",
    ],
    sampleUseCases: [
      "Appointment optimization",
      "Claims workflow modernization",
      "Clinical knowledge search",
    ],
  },
  {
    slug: "retail-ecommerce",
    title: "Retail & E‑commerce",
    challenges: ["Demand volatility", "Personalization", "Order and inventory accuracy"],
    solutions: ["Data-driven merchandising", "Cloud scalability", "Recommendation engines"],
    sampleUseCases: ["Cart conversion uplift", "Inventory forecasting", "Customer segmentation"],
  },
  {
    slug: "education-edtech",
    title: "Education & EdTech",
    challenges: ["Assessment integrity", "Scale during peak traffic", "Learning analytics"],
    solutions: ["Secure platforms", "Observability and performance", "Data dashboards"],
    sampleUseCases: ["Online proctored exams", "Performance insights", "Certificate verification"],
  },
  {
    slug: "manufacturing",
    title: "Manufacturing",
    challenges: ["Supply chain visibility", "Predictive maintenance", "ERP integration"],
    solutions: ["Analytics dashboards", "IoT data pipelines", "Workflow automation"],
    sampleUseCases: ["OEE dashboards", "Maintenance prediction", "Quality analytics"],
  },
  {
    slug: "logistics",
    title: "Logistics",
    challenges: ["Route optimization", "Real-time tracking", "Cost control"],
    solutions: ["Data platforms", "ML forecasting", "Mobile operational tools"],
    sampleUseCases: ["ETA prediction", "Fleet visibility", "Exception management"],
  },
  {
    slug: "startups",
    title: "Startups & SMBs",
    challenges: ["Speed to market", "Lean teams", "Unclear architecture choices"],
    solutions: ["MVP acceleration", "Cloud-native builds", "Pragmatic architecture"],
    sampleUseCases: ["MVP build in weeks", "Scaling roadmap", "Cost-aware cloud setup"],
  },
];

export const solutions = [
  {
    slug: "ai-powered-automation",
    title: "AI‑Powered Automation",
    summary: "Automate workflows using applied AI with enterprise guardrails.",
    bullets: [
      "Document + email automation",
      "Agentic workflows with approvals",
      "Knowledge assistants for internal teams",
    ],
  },
  {
    slug: "data-platforms",
    title: "Data Platforms",
    summary: "Modern analytics foundations designed for scale and governance.",
    bullets: ["Lakehouse setup", "BI enablement", "Governance + lineage"],
  },
  {
    slug: "custom-erp-crm",
    title: "Custom ERP / CRM",
    summary: "Workflows and integrations tailored to your operating model.",
    bullets: ["Role-based flows", "Integration hub", "Audit trails"],
  },
  {
    slug: "analytics-dashboards",
    title: "Analytics Dashboards",
    summary: "Decision-ready dashboards with reliability and trust.",
    bullets: ["KPI discovery", "Data validation", "Performance tuning"],
  },
  {
    slug: "cloud-migration",
    title: "Cloud Migration",
    summary: "Move safely with staged migration and cost-aware operations.",
    bullets: ["App assessment", "Landing zones", "Cutover planning"],
  },
  {
    slug: "startup-mvp-accelerator",
    title: "Startup MVP Accelerator",
    summary: "Build an MVP with strong foundations — without enterprise drag.",
    bullets: ["Rapid discovery", "MVP build", "Scale roadmap"],
  },
];

export const caseStudies = [
  {
    slug: "bfsi-risk-modernization",
    industry: "BFSI",
    title: "Risk analytics modernization for faster decisions",
    problem: "Disparate reports across teams created delays and inconsistent risk posture.",
    solution:
      "Built a governed data model with automated pipelines and a unified dashboard layer.",
    impact: "Reduced time-to-insight from days to hours and improved audit readiness.",
  },
  {
    slug: "retail-reliability",
    industry: "Retail",
    title: "Stabilizing peak traffic with cloud-native foundations",
    problem: "Checkout instability during campaigns caused revenue loss.",
    solution:
      "Introduced scalable infrastructure, CI/CD hardening, and performance baselines.",
    impact: "Improved availability and reduced incident response time significantly.",
  },
  {
    slug: "healthcare-knowledge-search",
    industry: "Healthcare",
    title: "Knowledge search for faster operational support",
    problem: "Support teams spent hours searching SOPs and policy docs.",
    solution: "Implemented secure knowledge search with structured retrieval patterns.",
    impact: "Faster resolution with consistent, governed answers.",
  },
];

export const jobs = [
  {
    id: "job-1",
    title: "Full‑Stack Engineer (React + Python)",
    location: "Bengaluru (Hybrid)",
    type: "Full‑time",
    experience: "2–5 yrs",
    tags: ["React", "FastAPI", "MongoDB"],
    description:
      "Build product-grade web apps with strong engineering hygiene and ownership.",
  },
  {
    id: "job-2",
    title: "Cloud / DevOps Engineer",
    location: "Bengaluru (Hybrid)",
    type: "Full‑time",
    experience: "3–7 yrs",
    tags: ["AWS", "Kubernetes", "Terraform"],
    description:
      "Design and automate cloud platforms with security, observability and cost discipline.",
  },
  {
    id: "job-3",
    title: "AI Engineer (Applied LLMs)",
    location: "Remote (India)",
    type: "Full‑time",
    experience: "2–6 yrs",
    tags: ["RAG", "Python", "MLOps"],
    description:
      "Ship practical AI systems (RAG, copilots, automation) from prototype to production.",
  },
];

export const internshipProgram = {
  title: "Internship Program",
  points: [
    "Weekly evaluation system with clear rubrics",
    "Stipend + offer logic based on performance",
    "Certificate policy with expectations",
    "Mentorship and real project exposure",
  ],
};

export const insights = {
  categories: ["AI in Business", "Cloud", "Engineering Culture", "Startup Tech"],
  posts: [
    {
      slug: "rag-enterprise-patterns",
      title: "RAG in the enterprise: architecture patterns that survive scale",
      category: "AI in Business",
      date: "2025-07-18",
      excerpt:
        "A practical guide to retrieval design, observability, and guardrails for production-ready assistants.",
      content: [
        "Enterprise RAG is not a demo — it’s a system.",
        "Start with your knowledge boundaries, define what ‘good answers’ mean, and enforce citations.",
        "Add telemetry early: retrieval hit-rate, groundedness checks, and fallback behavior.",
      ],
      readingMins: 7,
    },
    {
      slug: "cloud-cost-discipline",
      title: "Cloud cost discipline: a delivery-friendly FinOps playbook",
      category: "Cloud",
      date: "2025-06-02",
      excerpt:
        "How to set cost guardrails without slowing engineering teams — tagging, budgets and feedback loops.",
      content: [
        "Treat cost as a product requirement.",
        "Build feedback loops: show teams cost deltas per deployment.",
        "Automate rightsizing and keep budgets close to the teams.",
      ],
      readingMins: 6,
    },
    {
      slug: "quality-gates-that-scale",
      title: "Quality gates that scale: testing strategy for fast teams",
      category: "Engineering Culture",
      date: "2025-05-11",
      excerpt:
        "A layered testing approach that improves speed and confidence at the same time.",
      content: [
        "Don’t rely on a single test layer.",
        "Keep integration tests stable and small, and push business logic to unit tests.",
        "Make release confidence measurable with gates.",
      ],
      readingMins: 5,
    },
  ],
};

export const company = {
  about: {
    title: "About Ellipsonic",
    body: [
      "Ellipsonic engineers intelligent digital products and platforms for modern enterprises and fast-moving SMBs.",
      "We combine strong engineering fundamentals with AI-first thinking to deliver measurable outcomes — reliability, speed, and better decisions.",
    ],
    focus: ["India", "Global delivery"],
  },
  values: [
    {
      title: "Innovation",
      detail: "Practical innovation that ships: prototypes become products, and products become platforms.",
    },
    {
      title: "Integrity",
      detail: "Clear communication, honest estimates, and long-term partnership mindset.",
    },
    {
      title: "Engineering Excellence",
      detail: "High-quality architecture, testing discipline and performance baselines as defaults.",
    },
    {
      title: "Long‑term partnerships",
      detail: "We optimize for outcomes and trust, not just output.",
    },
  ],
  leadership: [
    {
      name: "Founder & Principal Consultant",
      bio: "Hands-on leadership that aligns architecture and delivery with business goals.",
    },
    {
      name: "Engineering Leadership",
      bio: "Senior engineers focused on quality, reliability and mentoring teams.",
    },
  ],
  engagementModels: [
    {
      title: "Fixed Price",
      detail: "Defined scope and delivery milestones with transparent acceptance criteria.",
    },
    {
      title: "Time & Material",
      detail: "Flexible delivery for evolving requirements with measurable weekly outcomes.",
    },
    {
      title: "Dedicated Teams",
      detail: "A managed team that integrates with your roadmap and engineering culture.",
    },
    {
      title: "Consulting & Advisory",
      detail: "Architecture reviews, modernization roadmaps and delivery acceleration.",
    },
  ],
  compliance: [
    "NDA-ready engagement",
    "Secure SDLC practices",
    "Access control and audit logging patterns",
  ],
};
